import { useAuthContext } from '../context/AuthContext';

export default function GuestRoute({ children }) {
    const { loading, isAuthenticated } = useAuthContext();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="w-10 h-10 border-4 border-border border-t-primary rounded-full animate-spin"></div>
            </div>
        );
    }

    if (isAuthenticated) {
        const redirectTo = location.state?.from?.pathname || '/';
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}
